import React, { Component, Fragment } from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { displayDateFormat, imgStoragePath } from '../../../../constants';
import { ordinalSuffixOf, getLocalStorageInfo } from '../../../../utils';
import { checkPermission } from '../../../../utils_v2';
import { InvoiceConfigCol } from '../../Elements';
import editIconWhite from '../../../../shared/assets/img/edit_icon_white.svg';
import { titanInstance,gaTelesisInstance, avationPlcInstance, mtInstance, leshaBankInstance, hanwahaInstance } from '../../../../shared_elements/components';
import { jetStreamInstance } from '../../../../lease_management/Leases';

export default class MRRateInvoiceInfo extends Component{
  constructor(props){
    super(props);
    this.state = {
      mrRateInvoiceInfo:{},
      showAllEmails: false,
    }
  }

  componentDidMount(){
    let data = this.props.mrRateInvoiceInfo
    // data = {
    //   ...data,
    //   mr_bank_account_name: this.props.mrRateInvoiceInfo.bank_account_name !== undefined && this.props.mrRateInvoiceInfo.bank_account_name !== null && this.props.mrRateInvoiceInfo.bank_account_name !== '' ? this.props.mrRateInvoiceInfo.bank_account_name : getLocalStorageInfo().defaultLessor.bank_account_name,
    //   mr_bank_code: this.props.mrRateInvoiceInfo.bank_code !== undefined && this.props.mrRateInvoiceInfo.bank_code !== null && this.props.mrRateInvoiceInfo.bank_code !== '' ? this.props.mrRateInvoiceInfo.bank_code : getLocalStorageInfo().defaultLessor.bank_code,
    //   mr_bank_iban: this.props.mrRateInvoiceInfo.bank_iban !== undefined && this.props.mrRateInvoiceInfo.bank_iban !== null && this.props.mrRateInvoiceInfo.bank_iban !== '' ? this.props.mrRateInvoiceInfo.bank_iban : getLocalStorageInfo().defaultLessor.bank_iban,
    //   mr_bank_name: this.props.mrRateInvoiceInfo.bank_name !== undefined && this.props.mrRateInvoiceInfo.bank_name !== null && this.props.mrRateInvoiceInfo.bank_name !== '' ? this.props.mrRateInvoiceInfo.bank_name : getLocalStorageInfo().defaultLessor.bank_name,
    //   mr_bank_note: this.props.mrRateInvoiceInfo.bank_note !== undefined && this.props.mrRateInvoiceInfo.bank_note !== null && this.props.mrRateInvoiceInfo.bank_note !== '' ? this.props.mrRateInvoiceInfo.bank_note : getLocalStorageInfo().defaultLessor.bank_note,
    //   mr_bank_reference: this.props.mrRateInvoiceInfo.bank_reference !== undefined && this.props.mrRateInvoiceInfo.bank_reference !== null && this.props.mrRateInvoiceInfo.bank_reference !== '' ? this.props.mrRateInvoiceInfo.bank_reference : getLocalStorageInfo().defaultLessor.bank_reference,
    //   mr_bank_sort_code: this.props.mrRateInvoiceInfo.bank_sort_code !== undefined && this.props.mrRateInvoiceInfo.bank_sort_code !== null && this.props.mrRateInvoiceInfo.bank_sort_code !== '' ? this.props.mrRateInvoiceInfo.bank_sort_code : getLocalStorageInfo().defaultLessor.bank_sort_code,
    //   mr_bank_account_number: this.props.mrRateInvoiceInfo.bank_account_number !== undefined && this.props.mrRateInvoiceInfo.bank_account_number !== null && this.props.mrRateInvoiceInfo.bank_account_number !== '' ? this.props.mrRateInvoiceInfo.bank_account_number : getLocalStorageInfo().defaultLessor.bank_account_number,
    //   mr_bank_swift_code: this.props.mrRateInvoiceInfo.bank_swift_code !== undefined && this.props.mrRateInvoiceInfo.bank_swift_code !== null && this.props.mrRateInvoiceInfo.bank_swift_code !== '' ? this.props.mrRateInvoiceInfo.bank_swift_code : getLocalStorageInfo().defaultLessor.bank_swift_code,
    //   mr_footer_note: this.props.mrRateInvoiceInfo.mr_footer_note !== undefined && this.props.mrRateInvoiceInfo.mr_footer_note !== null && this.props.mrRateInvoiceInfo.mr_footer_note !== '' ? this.props.mrRateInvoiceInfo.mr_footer_note : getLocalStorageInfo().defaultLessor.footer_note,
    //   mr_hub_number: this.props.mrRateInvoiceInfo.mr_hub_number !== undefined && this.props.mrRateInvoiceInfo.mr_hub_number !== null && this.props.mrRateInvoiceInfo.mr_hub_number !== '' ? this.props.mrRateInvoiceInfo.mr_hub_number : getLocalStorageInfo().defaultLessor.hub_number,
    //   mr_vat_number: this.props.mrRateInvoiceInfo.mr_vat_number !== undefined && this.props.mrRateInvoiceInfo.mr_vat_number !== null && this.props.mrRateInvoiceInfo.mr_vat_number !== '' ? this.props.mrRateInvoiceInfo.mr_footer_note : getLocalStorageInfo().defaultLessor.vat_number,
    // }
    this.setState({
      mrRateInvoiceInfo: data
    });
  }

  toggleEmails = () => {
    this.setState(prev => ({ showAllEmails: !prev.showAllEmails }));
  }
  render(){
    const { mrRateInvoiceInfo, contractInfo } = this.props;
    return(
      <div className="contract-invoice-config data-invoice-block">
        { checkPermission('contracts','reserve_rates','U') && contractInfo?.hdlineInfo?.archived_asset ==false ?
          <span style={{float:'right',marginRight:'23px'}}>
            <img
              onClick={this.props.toggleEditSideBar}
              src={editIconWhite}
              alt="edit"
              className="edit-card-icon"
              width="16"
              style={{zIndex:'5'}}
            />
          </span>:null
        }
        <Row>
          <InvoiceConfigCol
          size = "4"
            title="Invoice Generation Day"
            value={ mrRateInvoiceInfo.mr_invoice_day_of_month ? ordinalSuffixOf(mrRateInvoiceInfo.mr_invoice_day_of_month) + ' of Month':'--' }
          />
          <InvoiceConfigCol
            size = "4"
            title="Default Bank"
            value={ mrRateInvoiceInfo.reserve_default_bank?.name ? mrRateInvoiceInfo?.reserve_default_bank?.name:'--' }
          />
          <InvoiceConfigCol
          size = "4"
            title="Invoice Due Day"
            value={ mrRateInvoiceInfo.mr_invoice_due_day_of_month ? ordinalSuffixOf(mrRateInvoiceInfo.mr_invoice_due_day_of_month) + ' of Month':'--' }
          />
        </Row>      
        <Row>
        <InvoiceConfigCol
          size = "4"
            title="Invoice Due Month"
            value={ mrRateInvoiceInfo.mr_invoice_is_due_day_next_month ? 'Next Month':'Same Month' }
          />
          {hanwahaInstance ? <InvoiceConfigCol
            size="4"
            title="Account Code"
            value={mrRateInvoiceInfo?.reserve_account_code || '--'}
          /> : null}
          {jetStreamInstance ?
            <InvoiceConfigCol
              size="4"
              title="Invoice Due Day falls at last day of the Billing Month"
              value={mrRateInvoiceInfo.mr_invoice_is_due_day_last_day_month === true ? 'YES' : mrRateInvoiceInfo.mr_invoice_is_due_day_last_day_month === false ? 'NO' : '--'}
            /> : null
          }
          {(titanInstance ||gaTelesisInstance || avationPlcInstance || mtInstance || leshaBankInstance ) ? 
          <InvoiceConfigCol
            size="4"
            title="Reference Number"
            value={mrRateInvoiceInfo.reference_number_reserve ? mrRateInvoiceInfo.reference_number_reserve : '--'}
          /> : null}
          {gaTelesisInstance ?
            <>
              <InvoiceConfigCol
                size="4"
                title="QIS Number"
                value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.reserve_qis_number ? mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.reserve_qis_number : '--'}
              />
              <InvoiceConfigCol
                size="4"
                title="Sales Order Number"
                value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.reserve_sales_order_number ? mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.reserve_sales_order_number : '--'}
              />
            </> : null}
          {(titanInstance || avationPlcInstance || mtInstance || leshaBankInstance) ? <>
          <InvoiceConfigCol
              size="4"
              title="Remarks"
              value={mrRateInvoiceInfo.remarks_reserve ? mrRateInvoiceInfo.remarks_reserve : '--'}
            />
            <InvoiceConfigCol
              size="4"
              title="Remark Date"
              value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.remark_date ? mrRateInvoiceInfo.reserve_account_titan_extra_fields?.remark_date : '--'}
            /> 
          {(avationPlcInstance||mtInstance||leshaBankInstance) ? <>
          <InvoiceConfigCol
              size="4"
              title="Pledged"
              value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.pledged ? mrRateInvoiceInfo.reserve_account_titan_extra_fields?.pledged : '--'}
            />
          <InvoiceConfigCol
              size="4"
              title="Correction For Non Business Days"
              value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.correction_non_business_days ? mrRateInvoiceInfo.reserve_account_titan_extra_fields?.correction_non_business_days : '--'}
            /></>:null}
          <InvoiceConfigCol
              size="4"
              title="MR Payment Obligation"
              value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.mr_payment_obligation ? mrRateInvoiceInfo.reserve_account_titan_extra_fields?.mr_payment_obligation : '--'}
            />
          {(avationPlcInstance||mtInstance||leshaBankInstance)?<>
          <InvoiceConfigCol
              size="4"
              title="Interest Accrual"
              value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.interest_accrual ? mrRateInvoiceInfo.reserve_account_titan_extra_fields?.interest_accrual : '--'}
            />
            <InvoiceConfigCol
              size="4"
              title="Invoice/Reporting Frequency"
              value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.reporting_frequency ? mrRateInvoiceInfo.reserve_account_titan_extra_fields?.reporting_frequency : '--'}
            /></>:null}
          <InvoiceConfigCol
              size="4"
              title="Invoice Date"
              value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.due_date ? mrRateInvoiceInfo.reserve_account_titan_extra_fields?.due_date : '--'}
            />
             </>
            : ""}
          {titanInstance ? (
            <InvoiceConfigCol
              size="4"
              title="Email CC"
              value={mrRateInvoiceInfo?.reserve_account_emails && mrRateInvoiceInfo.reserve_account_emails.length > 0 ? (
                <span>
                  {(this.state.showAllEmails ? mrRateInvoiceInfo.reserve_account_emails : mrRateInvoiceInfo.reserve_account_emails.slice(0, 2) ).join(", ")}
                  {mrRateInvoiceInfo.reserve_account_emails.length > 2 && (
                    <span onClick={this.toggleEmails} style={{ color: "#f0a4ff", cursor: "pointer", marginLeft: 6 }} > <p style={{ color: "#f0a4ff", fontSize:'11px' }}>{this.state.showAllEmails ? " Show less" : " ... Show more"}</p> </span>
                  )}
                </span>) : "--"}
            />
          ) : null} 
         
        </Row>


        {
          ![14, 242].includes(getLocalStorageInfo().defaultLessor.id) ?
            <p style={{display:'none'}}>Invoice Sender</p>
          :null
        }
        {
          ![14, 242].includes(getLocalStorageInfo().defaultLessor.id) ?
          <Row style={{display:'none'}}>
            <InvoiceConfigCol
              size="4"
              title="Name"
              value={ mrRateInvoiceInfo.mr_from_company_name ? mrRateInvoiceInfo.mr_from_company_name:'--' }
            />
            <InvoiceConfigCol
              size="4"
              title="Company Address"
              value={ mrRateInvoiceInfo.mr_from_company_address ? mrRateInvoiceInfo.mr_from_company_address:'--' }
            />
            <InvoiceConfigCol
              size="4"
              title="Contact Details"
              value={ mrRateInvoiceInfo.mr_from_company_contact ? mrRateInvoiceInfo.mr_from_company_contact:'--' }
            />
          </Row>
          :null
        }
        {
          ![14, 242].includes(getLocalStorageInfo().defaultLessor.id) ?
            <p style={{display:'none'}}>Invoice Receiver</p>
          :null
        }
        {
          ![14, 242].includes(getLocalStorageInfo().defaultLessor.id) ?
          <Row style={{display:'none'}}>
            <InvoiceConfigCol
              size="4"
              title="Name"
              value={ mrRateInvoiceInfo.mr_to_company_name ? mrRateInvoiceInfo.mr_to_company_name:'--' }
            />
            <InvoiceConfigCol
              size="4"
              title="Company Address"
              value={ mrRateInvoiceInfo.mr_to_company_address ? mrRateInvoiceInfo.mr_to_company_address:'--' }
            />
            <InvoiceConfigCol
              size="4"
              title="Contact Details"
              value={ mrRateInvoiceInfo.mr_to_company_contact ? mrRateInvoiceInfo.mr_to_company_contact:'--' }
            />
          </Row>
          :null
        }
        <Row className="invoice-last-block" style={{display: 'none'}}>
          <InvoiceConfigCol
            size="4"
            title="Bank Name"
            value={ mrRateInvoiceInfo.mr_bank_name ? mrRateInvoiceInfo.mr_bank_name:'--' }
          />
          <InvoiceConfigCol
            size="4"
            title="Bank Account Name"
            value={ mrRateInvoiceInfo.mr_bank_account_name ? mrRateInvoiceInfo.mr_bank_account_name:'--' }
          />
          <InvoiceConfigCol
            size="4"
            title="Bank Account Number"
            value={ mrRateInvoiceInfo.mr_bank_account_number ? mrRateInvoiceInfo.mr_bank_account_number:'--' }
          />

          <InvoiceConfigCol
            size="4"
            title= {getLocalStorageInfo().defaultLessor.id==14?"Bank ABA":"Bank IBAN"}
            value={ mrRateInvoiceInfo.mr_bank_iban ? mrRateInvoiceInfo.mr_bank_iban:'--' }
          />
          <InvoiceConfigCol
            size="4"
            title="Bank Swift Code"
            value={ mrRateInvoiceInfo.mr_bank_swift_code ? mrRateInvoiceInfo.mr_bank_swift_code:'--' }
          />
          <InvoiceConfigCol
            size="4"
            title="Bank SORT Code"
            value={ mrRateInvoiceInfo.mr_bank_sort_code ? mrRateInvoiceInfo.mr_bank_sort_code:'--' }
          />
          {[14, 242].includes(getLocalStorageInfo().defaultLessor.id) ?
            <Fragment>
              <InvoiceConfigCol
                size="4"
                title="Hub Account"
                value={mrRateInvoiceInfo.mr_hub_number ? mrRateInvoiceInfo.mr_hub_number :'--'}
              />
              <InvoiceConfigCol
                size="4"
                title="VAT Number"
                value={mrRateInvoiceInfo.mr_vat_number ? mrRateInvoiceInfo.mr_vat_number :'--'}
              />
          </Fragment> :null
          }
          <InvoiceConfigCol
            size="4"
            title="Footer Note"
            value={ mrRateInvoiceInfo.mr_footer_note ? mrRateInvoiceInfo.mr_footer_note:'--' }
          />
        </Row>
     </div>
    )
  }
}
